<template>
  <div id="wrapper">
    <TextHeader
      header-bg="radial-gradient(circle farthest-corner at 13% 102%, #3b464e 21%, #080806)"
    />
    <div class="w-container">
      <SectionHeader :text="$t('navbar.management')" :show-back-text="true" />
      <div v-for="item in data" :key="item.name" class="manager-wrapper">
        <div
          class="manager-image"
          :style="{ backgroundImage: 'url(' + item.thumbnail + ')' }"
        ></div>
        <div class="manager-details">
          <h3 class="manager-name">{{ item.name }}</h3>
          <h4 class="manager-position">{{ item.position }}</h4>
          <div class="separator"></div>
          <div class="manager-description" v-html="item.description"></div>
          <a class="cv-link" :href="item.cv" target="_blank"
            >Descarcă CV-ul complet</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextHeader from "../TextHeader";
import SectionHeader from "../SectionHeader";

export default {
  name: "Leadership",
  data() {
    return {
      data: [
        {
          name: "Emil Pantelimon",
          thumbnail:
            "https://madrigal-public.s3.amazonaws.com/CACHE/images/emil_pantelimon/10bf1f44ec968af35cb2c8f133618fcd.jpg",
          description:
            "Este absolvent al Facultății de Științe Politice a Universității București și al Institutului Diplomatic Român - secția Politică Externă și Diplomație. A lucrat în cadrul cabinetelor a doi miniștri ai culturii din România pe probleme de comunicare și artele spectacolului, coordonând activitatea Biroului de presă din cadrul instituției. Timp de doi ani a făcut parte din grupul de acțiune a Planului Național de Acțiune pentru implementarea Angajamentelor Asumate prin Parteneriatul pentru o Guvernare Deschisă. În perioada 2011-2013 a lucrat la organizarea Festivalului Internațional „George Enescu”, în calitate de asistent al directorului general, iar din 2014 este Director de Comunicare al Operei Comice pentru Copii. 2015 a fost anul în care a devenit Manager al Corulului Național de Cameră „Madrigal-Marin Constantin”.",
          position:
            "Manager al Corului Național de Cameră „Madrigal-Marin Constantin”",
          cv:
            "https://madrigal-public.s3-eu-central-1.amazonaws.com/public-info/Pantelimon+Emil+CV.pdf",
        },
        {
          name: "Simona Haideu",
          thumbnail:
            "https://madrigal-public.s3-eu-central-1.amazonaws.com/management/simona-haideu.jpg",
          description:
            "Cu un doctorat în Muzică obținut în 2009 la Universitatea Naţională de Muzică din Bucureşti,\n" +
            "Simona Haideu are o vastă experiență corală si interpretativă. Este artist liric al Corului Național\n" +
            "de Cameră „Madrigal - Marin Constantin” încă din 1999, chiar din timpul facultății, iar din 2017\n" +
            "este și Director al Direcției Cor din cadrul Madrigal. Din 2014 activează ca maestru de studii\n" +
            "canto și formator în cadrul Programului Național Cantus Mundi, calitate în care susține\n" +
            "permanent workshop-uri și ateliere de pregătire pentru dirijori și coordonatori de cor, atât în\n" +
            "București, cât și în țară.",
          position: "Director Cor",
          cv:
            "https://madrigal-public.s3-eu-central-1.amazonaws.com/public-info/Haideu+Simona+Gabriela+CV.pdf",
        },
        {
          name: "Leila Popovici",
          thumbnail:
            "https://madrigal-public.s3-eu-central-1.amazonaws.com/management/leila-popovici.jpg",
          description:
            "Cu peste un deceniu de experiență în coordonarea profesioniștilor din IT în mediul corporatist, Leila Popovici urmărește să atingă și să mențină eﬁciența în ﬁecare proiect nou la care aderă. Licențiată în Studii Economice și în Management, deține un master în Managementul Resurselor Umane și în Comunicare Managerială. Sub coordonarea sa, Programul Național Cantus Mundi a dobândit noi repere, orientarea sa spre rezultate ﬁind unul dintre factorii cheie pentru succesul programului. Scopul său principal este să le dea copiilor din România vocea de care au nevoie pentru a depăși toate formele de discriminare - cântând împreună, într-un glas - astfel alocând o mare parte din energia sa schimbării în bine a României.",
          position: "Director Cantus Mundi",
          cv:
            "https://madrigal-public.s3-eu-central-1.amazonaws.com/public-info/Popovici_Alexandra_Leila_CV.pdf",
        },
      ],
    };
  },
  components: { TextHeader, SectionHeader },
  mounted() {},
};
</script>

<style scoped>
#wrapper {
  background-color: #f0f0f0;
}

.cv-link {
  margin-top: 0.5em;
  color: black;
}

.manager-wrapper {
  display: flex;
  flex-direction: row;
  padding: 38px 0;
  border-top: 1px solid #cbcbcb;
}

.manager-name {
  font-size: 2.5em;
}

.manager-image {
  width: 35%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
}

.manager-details {
  width: 65%;
  padding-left: 65px;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: stretch;
}

.manager-position {
  width: 60%;
  color: #777;
  font-weight: 300;
  font-size: 1.6em;
}

.separator {
  height: 6px;
  background-color: black;
  width: 25%;
  margin-top: 30px;
  margin-bottom: 15px;
}

.manager-description {
  color: #807d7d;
  font-size: 1em;
  line-height: 1.5em;
}

@media (max-width: 767px) {
  .manager-image {
    margin: 0 auto;
    height: calc(100vw - 60px);
    width: calc(100% - 30px);
    background-position: 0 20%;
  }

  .manager-wrapper {
    flex-direction: column;
  }

  .manager-details {
    width: 100%;
    padding: 0 15px;
    min-height: inherit;
  }

  .manager-position {
    width: 100%;
  }
}
</style>
